import React, {Component} from 'react'
import PropTypes from 'prop-types'
import PreviewImage from "./PreviewImage"


class ItemPreviewDetails extends Component {
    render() {
        const {item} = this.props
        const {product} = item
        const {mockUpFront, mockUpBack} = Object.assign({}, product)

        return (
            <div className="ItemPreviewDetails">
                <div className="d-flex">
                    {
                        !!mockUpFront &&
                        <div>
                            <PreviewImage url={mockUpFront}/>
                            <div className="text-center">
                                <h4>Mặt trước</h4>
                            </div>
                        </div>
                    }
                    {
                        !!mockUpBack &&
                        <div className="ml-3">
                            <PreviewImage url={mockUpBack}/>
                            <div className="text-center">
                                <h4>Mặt sau</h4>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

ItemPreviewDetails.propTypes = {
    item: PropTypes.object.isRequired,
}

export default ItemPreviewDetails
